// BSC主网地址

export const MINING_CONTRACT_ADDRESS = '0x03E333b86BB75575b5a1936193D21dCeeE413f5b';
export const CULTURE_ADDRESS = '0x27B925D32bb8e1633CaE40f2675286Be487a230B';
export const USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';

export const DEPLOY_BLOCK = 90000663; 
